import { Row, Col, Card, Empty } from 'antd';
import { AreaChart, Area, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import dayjs from 'dayjs';
import type { TrendData } from '@/types';

interface Props {
  data: TrendData | null;
  loading: boolean;
}

const formatDate = (date: string) => dayjs(date).format('MM-DD');

export default function TrendCharts({ data, loading }: Props) {
  if (loading) return <Row gutter={16}><Col span={12}><Card loading /></Col><Col span={12}><Card loading /></Col></Row>;
  if (!data) return <Empty />;

  return (
    <Row gutter={16}>
      <Col xs={24} lg={12}>
        <Card title="用户增长趋势" size="small">
          {data.userGrowth.length > 0 ? (
            <ResponsiveContainer width="100%" height={260}>
              <AreaChart data={data.userGrowth}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" tickFormatter={formatDate} fontSize={12} />
                <YAxis fontSize={12} />
                <Tooltip labelFormatter={(v) => dayjs(v).format('YYYY-MM-DD')} />
                <Area type="monotone" dataKey="count" stroke="#1677ff" fill="#1677ff" fillOpacity={0.15} name="新增用户" />
              </AreaChart>
            </ResponsiveContainer>
          ) : (
            <Empty description="暂无数据" image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )}
        </Card>
      </Col>
      <Col xs={24} lg={12}>
        <Card title="营收趋势" size="small">
          {data.revenue.length > 0 ? (
            <ResponsiveContainer width="100%" height={260}>
              <BarChart data={data.revenue}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" tickFormatter={formatDate} fontSize={12} />
                <YAxis fontSize={12} />
                <Tooltip labelFormatter={(v) => dayjs(v).format('YYYY-MM-DD')} formatter={(v: number) => [`¥${v.toFixed(2)}`, '营收']} />
                <Bar dataKey="amount" fill="#52c41a" name="营收" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          ) : (
            <Empty description="暂无数据" image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )}
        </Card>
      </Col>
    </Row>
  );
}
